import { render, staticRenderFns } from "./FormType8.vue?vue&type=template&id=6d03f5c1&"
import script from "./FormType8.vue?vue&type=script&lang=js&"
export * from "./FormType8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports